/**
 * @description 路由文件
 */
import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import LayoutLanding from './LayoutLanding.js'
import LayoutAdmin from './LayoutAdmin.js'
import ErrorPage from './pages/ErrorPage.js'
import HomePage from './pages/Home/Home.js'
import Page404 from './pages/Page404.js'
import LocationDashboard from './pages/LocationDashboard/index.js'
import AppScreenshot from './pages/AppScreenshot/index.js'
import AdminAuth from './components/AdminAuth.js'
import ErrorDashboard from './components/ErrorDashboard.js'
import TimelineImages from './pages/TimelineImages/index.js'
import ScanImages from './pages/ScanImages/index.js'
import TrackPointViewer from './pages/TrackPointViewer/index.js'
import TrackPoints3D from './pages/TrackPoints3D/index.js'
import RevenueCatProxyDashboard from './pages/RevenueCatProxy/index.js'
import UsageDashboardPage from './pages/UsageDashboard/index.js'

const router = createBrowserRouter([
  {
    path: '/',
    element: <LayoutLanding />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/home',
        element: <HomePage />,
      },
    ],
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin',
    element: (
      <AdminAuth>
        <LayoutAdmin />
      </AdminAuth>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="location" replace />,
      },
      {
        path: 'location',
        element: <LocationDashboard />,
      },
      {
        path: 'usage',
        element: <UsageDashboardPage />,
      },
      {
        path: 'revenuecat',
        element: <RevenueCatProxyDashboard />,
      },
      {
        path: 'errors',
        element: <ErrorDashboard />,
      },
      {
        path: 'timeline-images',
        element: <TimelineImages />,
      },
      {
        path: 'scan-images',
        element: <ScanImages />,
      },
      {
        path: 'trackpoints',
        element: <TrackPointViewer />,
      },
      {
        path: 'trackpoints-3d',
        element: <TrackPoints3D />,
      },
    ],
  },
  {
    path: '/app-screenshot',
    element: <AppScreenshot />,
  },
  {
    path: '*',
    element: <Page404 />,
  },
])

export default function Root() {
  return <RouterProvider router={router} />
}
